/**
 * Format utilities for display
 */

import type { LucideIcon } from "lucide-react";
import {
  FileText,
  Video,
  File,
  Image,
  FileSpreadsheet,
  FileAudio,
} from "lucide-react";

/**
 * Get icon component for file type
 */
export function getFileTypeIcon(fileType: string): LucideIcon {
  const normalized = fileType?.toLowerCase().trim() || "";
  switch (normalized) {
    case "pdf":
    case "doc":
    case "docx":
      return FileText;
    case "video":
    case "mp4":
    case "webm":
    case "mov":
      return Video;
    case "image":
    case "png":
    case "jpg":
    case "jpeg":
    case "gif":
    case "webp":
      return Image;
    case "xls":
    case "xlsx":
    case "csv":
      return FileSpreadsheet;
    case "audio":
    case "mp3":
    case "wav":
      return FileAudio;
    default:
      return File;
  }
}
